<template>
    <div class="overview-container">
        <div v-if="getCurrentViberCampaign" class="info-container">
            <v-card class="table-wrapper">
                <campaign-table :rows="campaignTableRows">
                    <template v-slot:fallback_icon>
                        <two-state-icon
                            :condition="getCurrentViberCampaign.fallback ?? false"
                            class="fallback-icon"
                        />
                    </template>
                </campaign-table>
                <create-form-actions
                    needs-padding
                    has-submit-btn
                    :submit-loading="submitLoading"
                    :submit-disabled="submitLoading"
                    has-previous-step-btn
                    @previous-step="emitPrevStep"
                    @cancel="emitCancel"
                    @reset="emitReset"
                    @submit-campaign="submitCampaign"
                />
            </v-card>
        </div>
        <div id="export" />
    </div>
</template>

<script>
    import dateTimeUtils from '@/utils/date-time-utils'
    import recurringViberCampaignService from '@/services/recurring-viber-campaign-service'
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import CampaignTable from '@/components/CampaignTable.vue'
    import TwoStateIcon from '@/components/TwoStateIcon.vue'
    export default {
        components: { TwoStateIcon, CampaignTable, CreateFormActions },
        data() {
            return {
                submitLoading: false
            }
        },
        computed: {
            getCurrentViberCampaign() {
                return this.$store.getters.getCurrentRecurringViberCampaign
            },
            campaignTableRows() {
                return [
                    {
                        header: 'Campaign :',
                        value: this.getCurrentViberCampaign.alias
                    },
                    {
                        header: 'Originator :',
                        value: this.getCurrentViberCampaign.originator
                    },
                    {
                        header: 'Text Template :',
                        value: this.getCurrentViberCampaign.textTemplate
                    },
                    {
                        header: 'Alias :',
                        value: this.getCurrentViberCampaign.alias
                    },
                    {
                        header: 'TTL :',
                        value: this.getCurrentViberCampaign.ttl
                    },
                    {
                        header: 'SMS Fallback :',
                        type: 'slot',
                        slot: 'fallback_icon'
                    },
                    {
                        header: 'SMS Fallback Text Template :',
                        value: this.getCurrentViberCampaign.fallbackTextTemplate ?? '-'
                    },
                    {
                        header: 'Button text :',
                        value: this.getCurrentViberCampaign.buttonCaption ?? '-'
                    },
                    {
                        header: 'Button Url :',
                        value: this.getCurrentViberCampaign.buttonUrl ?? '-'
                    },
                    {
                        header: 'Image Url :',
                        value: this.getCurrentViberCampaign.imageUrl ?? '-'
                    },
                    {
                        header: 'Created At :',
                        value: this.getHumanizedDateTime(
                            this.getCurrentViberCampaign.createdAt
                        )
                    }
                ]
            }
        },
        methods: {
            getHumanizedDateTime(dateTime) {
                return dateTimeUtils.getHumanizedDateTime(dateTime)
            },
            submitCampaign() {
                this.submitLoading = true
                return recurringViberCampaignService
                    .createViberCampaign(this.getCurrentViberCampaign)
                    .then((resp) => {
                        const campaignAfterCreate = {
                            ...this.getCurrentViberCampaign,
                            id: resp.data.id
                        }
                        this.$store.dispatch(
                            'setRecurringViberCampaign',
                            campaignAfterCreate
                        )
                        this.submitLoading = false
                        this.$emit('set-alert', 'Campaign Created', 'success')
                        setTimeout(() => {
                            this.$router.push(
                                `/recurring-viber/${this.getCurrentViberCampaign.id}`
                            )
                        }, 3000)
                    })
                    .catch((error) => {
                        this.$emit('set-alert', error.response.data.message, 'error')
                    })
            },
            emitPrevStep() {
                this.$emit('prev-step')
            },
            emitCancel() {
                this.$emit('cancel')
            },
            emitReset() {
                this.$emit('reset')
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.overview-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.info-container {
    display: flex;
    column-gap: 10px;
}

.fallback-icon {
    text-align: center;
    padding: 5px;
    width: 50px;
}

.table-wrapper {
    padding-bottom: 1rem;
    width: 100%;
}

@media screen and (max-width: 992px) {
    .info-container {
        row-gap: 10px;
        flex-wrap: wrap;
    }
}
</style>
